<div 
  #citationsContainer
  cdkDropListGroup
  class="token_container scrollbar"
  [style.padding.px]="items?.length ? '4' : '0'"
  [style.paddingRight.px]="items?.length ? '18' : '0'"
  [style.paddingBottom.px]="items?.length ? '2' : '0'">

  <ng-container *ngIf="!(citationsEventService.citationQueueLoading$ | async), else loadingTemplate">
    <span 
      title="Right-click for more options"
      cdkDropList 
      [cdkDropListData]="i" 
      *ngFor="let item of items; let i = index;"
      [contextMenu]="contextMenuComponent"
      [contextMenuSubject]="item">
      <span 
        cdkDrag 
        [cdkDragData]="i" 
        (cdkDragEntered)="drop($event)" 
        class="token_item">
        <span>
          <ng-container *ngIf="item.article?.authors?.length, else unknownAuthorTemplate">
            {{ item.import_data?.source === 'janssen_endnote' ? (item.article?.authors[0] | truncate) : (item.article?.authors[0] | formatAuthor | truncate) }}&#44; 
          </ng-container>
          <ng-template #unknownAuthorTemplate>
            Unknown author&#44; 
          </ng-template>
          {{ item.article?.year ?  item.article?.year : getYear(item)}}
        </span>
        <span
          class="pointer" 
          (click)="openContextMenu($event, item)">
          <fa-icon [icon]="['fas', 'cog']"></fa-icon>
        </span>
      </span>
    </span>
    <div 
      *ngIf="items.length"
      class="token_icon"
      (click)="onOverrideClick()">
      <fa-icon [icon]="['fal', 'edit']"></fa-icon>
    </div>
  </ng-container>
  
  <ng-template #loadingTemplate>
    <div class="padding-top-sm padding-bottom-xs">
      <scs-loader [isSmall]="true"></scs-loader>
    </div>
  </ng-template>

</div>

<context-menu #contextMenuComponent>
  <ng-template 
    contextMenuItem 
    (execute)="removeItem($event.item, true)" 
    let-item>
    Remove citation
  </ng-template>
  <ng-template 
    contextMenuItem 
    (execute)="itemsDisplayService.showItemOptionsPanel($event.item)" 
    let-item>
    Edit in-line citation
  </ng-template>
  <ng-template 
    contextMenuItem 
    (execute)="urlService.editReference($event.item)" 
    [visible]="isLibraryItem" 
    let-item>
    Edit reference details
  </ng-template>
  <ng-template 
    contextMenuItem 
    (execute)="urlService.viewReference($event.item)" 
    [visible]="isLibraryItem" 
    let-item>
    View reference details
  </ng-template>
  <ng-template 
    contextMenuItem 
    (execute)="urlService.viewArticle($event.item)" 
    [visible]="isLibraryItem && hasPdf" 
    let-item>
    View PDF
  </ng-template>
</context-menu>